module.exports = __webpack_public_path__ + "img/P150T_weapon_62.81916c6f.png";